import { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { TARGET_LANGUAGE } from 'src/utils/language/saveLastLanguagePair';
import { getLocalStorageEntry } from 'src/utils/webStorageUtils';
import { PreCheckpointScreenView } from './PreCheckpointScreenView';
import { useGoodLuckCelebrationMedia } from './useGoodLuckCelebrationMedia';

export type PreCheckpointScreenProps = {
  targetLanguageLocale?: string | null;
  onContinue: () => void;
  isContinuing?: boolean;
  onBack: () => void;
};

/**
 * The overlay is `position: fixed`, but EOS (and other callers) nest this
 * screen under ancestors with `transform` / `overflow`. Those create a new
 * containing block, so the takeover shrinks into the parent and the CTAs
 * fall off-screen. Portal to `document.body` so it always covers the viewport.
 */
const Portal = ({ children }: { children: ReactNode }) => {
  /* istanbul ignore next: SSR has no document */
  if (typeof document === 'undefined') {
    return <>{children}</>;
  }

  return createPortal(children, document.body);
};

export const PreCheckpointScreen: FC<PreCheckpointScreenProps> = ({
  targetLanguageLocale,
  onContinue,
  isContinuing,
  onBack,
}) => {
  const locale = targetLanguageLocale ?? getLocalStorageEntry(TARGET_LANGUAGE);
  const media = useGoodLuckCelebrationMedia(locale);

  return (
    <Portal>
      <PreCheckpointScreenView
        media={media}
        onContinue={onContinue}
        isContinuing={isContinuing}
        onBack={onBack}
      />
    </Portal>
  );
};
